import { useState } from "react";
import { useApiUrl } from "@refinedev/core";
import { Header } from "@tanstack/react-table";
import Papa from "papaparse";
import axiosInstance from "axiosInstance";
import { ReviewRequestBlacklist } from "entities/review_request_blacklist";
import { generateFilter } from "@refinedev/simple-rest";
import { stringify } from "query-string";

export default function useExportCsv(
  headers: Header<ReviewRequestBlacklist, unknown>[]
) {
  const apiUrl = useApiUrl();
  const [isExporting, setIsExporting] = useState(false);

  const exportCsv = async () => {
    setIsExporting(true);
    try {
      const filters = headers
        .filter((h) => h.column.getIsFiltered())
        .map((h) => {
          const operator =
            (h.column.columnDef.meta as any)?.filterOperator ?? "eq";
          return {
            field: h.id,
            operator,
            value: h.column.getFilterValue(),
          };
        });

      const queryFilters = generateFilter(filters as any);
      const query = {
        _start: 0,
        _end: 1000,
      };

      const url = `${apiUrl}/review_request_blacklists?${stringify(query, { arrayFormat: "bracket" })}&${stringify(queryFilters, { arrayFormat: "bracket" })}`;
      const { data } = await axiosInstance.get(url);

      const rows = (data as ReviewRequestBlacklist[]).map((row) => ({
        id: row.id,
        email: row.email,
        reason: row.reason,
        source_detail: row.source_detail,
        created_at: row.created_at,
      }));

      const csv = Papa.unparse(rows);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "review_request_blacklists_export.csv";
      link.click();
      URL.revokeObjectURL(link.href);
    } finally {
      setIsExporting(false);
    }
  };

  return { exportCsv, isExporting };
}
